import * as types from './mutations-types'

import services from '@/services'

import i18n from '@/i18n'

export const handleProactiveMessages = async ({ dispatch, getters }) => {
  const { flux, active, manualCloseProactiveMessage } = getters

  if (flux && !active) {
    if (
      flux.message &&
      flux.message.enabled &&
      flux.message.comment &&
      !manualCloseProactiveMessage
    ) {
      await dispatch('setProactiveMsgVisible', true)
    }
  }
}

export const setStoriesList = ({ commit }, storiesList) => {
  commit(types.SET_STORIES_LIST, storiesList)
}

export const setStories = ({ commit }, stories) => {
  commit(types.SET_STORIES, stories)
}

export const setShowStories = ({ commit }, show) => {
  commit(types.SET_SHOW_STORIES, show)

  services.iframe.changeIFrameClasses()
}

export const setProactiveMsgVisible = ({ commit }, payload) => {
  commit(types.SHOW_PROACTIVE_MSG, payload)

  services.iframe.changeIFrameClasses()
  if (payload === false) {
    services.iframe.changeIframeStyles('')
  }
}

export const openChatFromStories = async ({ getters, dispatch }, storie) => {
  const { chat, restoringSession } = getters

  await dispatch('setSelectedStories', storie)

  await dispatch('chooseFlux')

  if (!chat && !restoringSession) {
    const options = {
      customFields: [
        {
          id: 'conversion_type',
          value: storie.title,
          title: i18n.t('stories.customFieldTitle')
        },
        {
          id: 'is_lead',
          value: 'Sim',
          title: 'is_lead'
        }
      ]
    }

    await dispatch('createChat', options)
  }

  await dispatch('activeApp')
}

export const setSelectedStories = ({ commit }, storie) => {
  commit(types.SET_SELECTED_STORIES, storie)
}

export const enableVueperStories = ({ commit }) => {
  commit(types.ENABLE_VUEPER_STORIES)
}

export const disableVueperStories = ({ commit }) => {
  commit(types.DISABLE_VUEPER_STORIES)
}

export const sendStorySendStatistic = async (_, { storyId, fluxId }) => {
  await services.flux
    .fluxStatistics(fluxId)
    .sended(`?story_media_id=${storyId}`)
}

export const sendStoryOpenStatistic = async (_, { storyId, fluxId }) => {
  await services.flux
    .fluxStatistics(fluxId)
    .opened(`?story_media_id=${storyId}`)
}

export const manualCloseProactiveMessage = ({ commit }) => {
  commit(types.MANUAL_CLOSE_PROACTIVE_MESSAGE)

  commit(types.SHOW_PROACTIVE_MSG, false)

  services.iframe.changeIFrameClasses()

  services.iframe.changeIframeStyles('')
}
